export const FINANCIAL_DATA_SUMMARY_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.FinancialDataSummaryInvalidated";
